import React from 'react';
import { Grid, TextField, MenuItem } from '@mui/material';

// The agency's fee for a property or a unit.
//
// Shared because the two forms must offer exactly the same choices: a fee entered one way
// on a property and another way on a unit would resolve through the same cascade and be
// impossible to compare on screen.
//
// Leaving the type blank is a real answer, not an empty one — it means "inherit", which is
// what most properties and nearly every unit should be. Only the ones that negotiated
// their own terms set anything here.
const FeeTermsFields = ({ value, onChange, inheritsFrom, currency = 'UGX' }) => {
  const feeType = value.feeType || '';
  const isFixed = feeType === 'fixed';

  const setType = (next) => {
    // Clearing the type clears the amount with it. A stray value left behind under
    // "inherit" would be invisible on screen and reappear the moment someone picked a
    // type again.
    if (!next) return onChange({ feeType: '', feeValue: '' });
    return onChange({ feeType: next, feeValue: value.feeValue ?? '' });
  };

  return (
    <>
      <Grid item xs={6}>
        <TextField
          fullWidth
          select
          label="Agency Fee Basis"
          value={feeType}
          onChange={(e) => setType(e.target.value)}
          helperText={inheritsFrom ? `Leave blank to inherit ${inheritsFrom}` : 'Leave blank to inherit'}
        >
          <MenuItem value="">Inherit</MenuItem>
          <MenuItem value="percentage">Percentage of rent collected</MenuItem>
          <MenuItem value="fixed">Fixed amount per month</MenuItem>
        </TextField>
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          type="number"
          label={isFixed ? `Fee Amount (${currency})` : 'Fee Percentage (%)'}
          value={value.feeValue ?? ''}
          disabled={!feeType}
          onFocus={(e) => e.target.select()}
          onChange={(e) => onChange({ feeType, feeValue: e.target.value })}
          inputProps={isFixed ? { min: 0 } : { min: 0, max: 100 }}
          helperText={isFixed
            // The one thing about a fixed fee that surprises people, said where they set it.
            ? 'Earned only once the month is paid in full'
            : 'Earned as rent is collected'}
        />
      </Grid>
    </>
  );
};

export default FeeTermsFields;
